export default {
    widgetEnable: 'Vidjet yoqadi',
    signInText: "O'z kabinetingizga kiring",
    password: 'Parol',
    login: 'Kirish',
    signin: 'Kirish',
    loginTooltip1: 'Foydalanuvchi nomini kiriting',
    loginTooltip2: 'Parolni kiriting',
    forgotPassword: 'Parolni unutdingizmi',
    registerNow: "Ro'yxatga olmoq",
    registerHere: "Ro'yxatga olmoq",
    dontHaveAccount: `hali hisobingiz yo'q ? `,
    loginText: 'Avakusga xush kelibsiz',
    taskManagement: 'Vazifalarni boshqarish',
    search: 'Qidirmoq',
    reset: 'Takrorlash',
    businessKey: 'Biznes kalit',
    name: 'Ism',
    companyName: 'Shirkat nomi',
    downPaymentGreater: "Dastlabki to'lov umumiy buyurtma miqdoridan oshmasligi kerak",
    clientName: 'Mijoz ismi',
    created: 'Yaratilgan',
    action: 'Harakat',
    actions: 'Harakatlar',
    taskDetail: 'Vazifa tafsilotlari',
    bniDirect: 'BNI Direct',
    key: 'Kalit',
    value: 'Qiymati',
    keywords: "kalit so'zlar",
    registeredDate: 'Roʻyxatdan oʻtgan sana',
    settlementDetail: 'hisob-kitob tafsilotlari',
    relation: 'Aloqa',
    customerReport: 'mijoz hisoboti',
    creditType: 'kredit turi',
    relationDetail: 'munosabat tafsiloti',
    accept: 'Qabul qilmoq',
    approve: "Ma'qullamoq",
    reject: 'Rad qilmoq',
    complete: "To'liq",
    edit: 'Tahrirlamoq',
    revise: "Qayta ko'rib chiqmoq",
    normalPayment: "Oddiy to'lov",
    documentDetail: 'Hujjat tafsilotlari',
    documentType: 'Hujjat turi',
    specificReference: 'Maxsus havola',
    specificDocumentStatus: 'Maxsus hujjat holati',
    amountRange: "Miqdori oralig'i",
    periodRange: "Davrlar oralig'i",
    transactionFilter: 'Tranzaktsiya filtri',
    dateRange: "Sana oralig'i",
    advanceSearch: 'Rivojlangan',
    documentStatus: 'Hujjat holati',
    period: 'Davr',
    amount: 'Miqdor',
    amountMinimum: 'Minimal miqdor',
    amountMaximum: 'Maksimal miqdor',
    documentReference: 'Hujjatning havolasi',
    reference: "Ma'lumotnoma",
    seller: 'Sotuvchi',
    buyer: 'Xaridor',
    status: 'Holat',
    dueDate: 'Muddati',
    currency: 'Pul',
    type: 'Tur',
    received: 'Qabul qilindi',
    dateReceived: 'Qabul qilingan sana',
    accountDetail: 'Hisob tafsilotlari',
    disbursementDetails: "To'lov tafsilotlari",
    disbursementTransferDate: "To'lovni o'tkazish sanasi",
    settlementTransferDate: "Hisob-kitoblarni o'tkazish sanasi",
    paymentDate: 'Transfer sanasi',
    maturityDate: 'Tugallangan muddat',
    totalNumber: 'Natijalarning umumiy soni',
    totalAmountDoc: 'Hujjatlarning umumiy hajmi',
    userManagement: 'Foydalanuvchi boshqaruvi',
    bankManagement: 'Bank boshqaruvi',
    bankInformation: "Bank haqida ma'lumot qo'shish",
    localBankCode: 'Mahalliy bank kodi',
    branchCode: 'Filial kodi',
    postCode: 'Pochta kodi',
    'bankName.isEmpty': 'Bank nomi talab qilinadi',
    bankInformationisAlreadyExist: "Bank ma'lumotlari allaqachon mavjud",
    bankInformationHasBeenCreated: "Bank ma'lumotlari yaratildi",
    deleteMessage: "Ushbu ma'lumotlarni o'chirishni xohlaganingizga ishonchingiz komilmi?",
    add: "Qo'shmoq",
    addReferenceRate: "Ma'lumot berish narxini qo'shing",
    addCommissionSetting: "Komissiya sozlamalarini qo'shish",
    userName: 'Foydalanuvchi nomi',
    view: "Ko'rinish",
    delete: "O'chirmoq",
    cancel: 'Bekor qilmoq',
    provideValidationMessages: "* Iltimos, haqiqiy ma'lumotlarni taqdim eting",
    validationUsernameMessages: '* Iltimos, foydalanuvchi nomingizni kiriting',
    validationPasswordMessages: '* Iltimos, parolingizni kiriting',
    validationUpdatePasswordMessage:
        '* Iltimos, raqam, bosh harf, kichik harf va kamida 9 belgini kiriting.',
    save: 'Saqlash',
    userDetail: 'Foydalanuvchi tafsilotlari',
    username: 'Foydalanuvchi nomi',
    firstName: 'Ism',
    middleName: 'Otasini ismi',
    lastName: 'Familiya',
    email: 'Elektron pochta',
    lastLoginTime: "So'nggi kirish vaqti",
    account: 'Hisob',
    emailAddress: 'Elektron pochta manzili',
    emailNotification: 'Elektron pochta xabarnomasi',
    mobileNumber: 'Mobil telefon raqam',
    smsNotification: 'SMS xabar',
    city: 'Shahar',
    country: 'Mamlakat',
    languageISOCode: 'Til ISO kodi',
    postalCode: 'Pochta Indeksi',
    address: 'Manzil',
    jobTitle: 'Lavozim',
    personTitle: 'Prefiks',
    idType: 'ID turi',
    idNumber: 'ID raqami',
    otp: 'Bir martalik parol (OTP)',
    settings: 'Sozlamalar',
    pph23Flagging: 'PPT 23',
    deleteUserLDAP: "Foydalanuvchi LDAP-ni o'chirish",
    createUserLDAP: 'Foydalanuvchi LDAP-ni yaratish',
    resetPassword: 'Parolni qayta tiklash',
    option: 'Tanlov',
    organizationManagement: 'Tashkilotni boshqaruvi',
    organizationDetail: "Tashkilot haqida ma'lumot",
    fullName: "To'liq ism",
    timezone: 'Vaqt zonasi',
    contactPerson: "Bog'lanish uchun shaxs",
    contactPersonDepartment: "Bog'lanuvchi shaxs bo'limi",
    contactPersonPhone: "Bog'lanuvchi Shaxs telefoni",
    contactPersonEmail: "Bog'lanuvchi shaxs elektron pochtasi",
    industry: "Yo'nalish",
    subIndustry: 'Kichik sanoat',
    billingAccountName: "To'lov hisob nomi",
    billingAccountNumber: "To'lov hisob raqami",
    billingTaxable: "Soliqqa tortiladigan to'lov",
    calendar: 'Kalendar',
    authorization: 'Avtorizatsiya',
    organizationCalendar: 'Tashkilot kalendari',
    organizationCalendarDetail: 'Tashkilot kalendari tafsiloti',
    exclusions: 'Istisnolar',
    addExclusions: "Istisnolar qo'shish",
    date: 'Sana',
    description: 'Tavsif',
    organizationAuthorization: 'Tashkilotning avtorizatsiyasi',
    organization: 'Tashkilot',
    organizations: 'Tashkilotlar',
    role: 'Rol',
    user: 'Foydalanuvchi',
    authorizationDetail: 'Avtorizatsiya tafsilotlari',
    authorizationDetailForm: 'Avtorizatsiya tafsilotlari shakli',
    roleManagement: 'Rolni boshqarish',
    roleDetail: 'Rol tafsilotlari',
    rolePermission: 'Rolga ruxsat',
    roleAssign: 'Rol tayinlash',
    programManagement: 'Dasturni boshqarish',
    programDetail: 'Dastur tafsilotlari',
    supportedCurrencies: "Qo'llab-quvvatlanadigan valyutalar",
    funderEnable: 'Moliyalashtiruvchini yoqish',
    funderMultiple: "Moliyalashtiruvchini ko'paytirish",
    funderConfigurations: 'Moliyalashtiruvchi konfiguratsiyasi',
    buyerEnable: 'Xaridorni yoqish',
    buyerMultiple: "Xaridorni ko'paytirish",
    buyerConfigurations: 'Xaridor konfiguratsiyalari',
    sellerEnable: 'Sotuvchini yoqish',
    sellerMultiple: "Sotuvchini ko'paytirish",
    sellerConfigurations: 'Sotuvchi konfiguratsiyalar',
    pleaseSelect: 'Iltimos tanlang...',
    contractManagement: 'Shartnomani boshqarish',
    contractDetail: 'Shartnoma tafsiloti',
    contractName: 'Shartnoma nomi',
    contractAdd: "Shartnoma qo'shish",
    contractEdit: 'Shartnomani tahrirlash',
    assignProgram: 'Dastur tayinlash',
    deactivatedContract: "Shartnomani o'chirish",
    organizationName: 'Tashkilot nomi',
    buyerOrganizations: 'Xaridor tashkilotlari',
    sellerOrganizations: 'Sotuvchilar tashkilotlari',
    funderOrganizations: 'Moliyalashtiruvchi tashkilotlari',
    uploadQuotes: 'Sitata( iqtibos)larini yuklash',
    upload: 'Yuklamoq',
    buyerName: 'Xaridor nomi',
    supplierCode: 'Yetkazib beruvchi kodi',
    supplierName: 'Yetkazib beruvchii nomi',
    sellerName: 'Sotuvchi nomi',
    areaCode: 'Hudud kodi',
    salesCode: 'Savdo kodi',
    quoteNumber: ' Sitata( iqtibos) raqami',
    paymentTerm: "To'lov muddati",
    warehouseCode: 'Omborlar kodi',
    deliveryFrom: 'dan yetkazib berish ',
    deliveryTo: 'ga yetkazib berish',
    creationDate: 'Yaratilgan sanasi',
    tags: 'Holat',
    expectedDeliveryDate: 'Kutilayotgany etkazib berish sanasi',
    addLineItem: "Chiziq elementini qo'shish",
    code: 'Kod',
    uom: "O'lchov birligi",
    price: 'Narx',
    qty: 'Miqdori',
    vat: "Qo'shilgan qiymat solig'i (QQS)",
    discount: 'Chegirma',
    submit: 'Topshirmoq',
    createQuote: 'Iqtibos yarating',
    createInvoice: 'Hisob-fakturani yarating',
    createShippingLetter: 'Yetkazib berish xatini yarating',
    senderName: 'Yuboruvchining ismi',
    receiverName: 'Qabul qiluvchining ismi',
    deliveryDate: 'Yetkazib berish sanasi',
    expiryDate: 'Tugash muddati',
    lineItems: 'Chiziqli narsalar',
    itemCode: 'Element kodi',
    no: "Yo'q",
    documentView: "Hujjatlarni ko'rish",
    despatchAdvice: "Jo'natish maslahati",
    despatchAdviceInventoryChecking: 'Inventarizatsiya tekshiruvi',
    tracingNumber: 'Kuzatuv raqami',
    buyerCode: 'Xaridor kodi',
    buyerFullName: "Xaridor to'liq ism",
    buyerContact: 'Xaridor kontakti',
    sellerCode: 'Sotuvchi kodi',
    sellerFullName: "Sotuvchi to'liq ism",
    sellerContact: 'Sotuvchi kontakti',
    orderReference: "Buyurtma ma'lumotnomasi",
    orderDate: 'Buyurtma sanasi',
    receiveDate: 'Sanani qabul qilish',
    despatchedQuantity: "Jo'natilgan miqdor",
    receivedQuantity: 'Qabul qilingan miqdor',
    serviceLevel: "Xizmat ko'rsatish darajasi",
    referenceSourceManagement: "Ma'lumot manbalari boshqarmasi",
    ReferenceSourceAdd: "Ma'lumot manbasini qo'shish",
    referenceSourceDetail: "Ma'lumot manbasi tafsilotlari",
    referenceSourceEdit: "Ma'lumot manbasini tahrirlash",
    invoice: 'Hisob faktura',
    buyerNPWP: "Xaridorni ro'yxatdan o'tkazish raqami",
    sellerNPWP: "Sotuvchilarni ro'yxatdan o'tkazish raqami",
    despatchAdviceReference: "Jo'natish maslahati ma'lumotnomasi",
    receivingAdviceReference: "Maslahat ma'lumotlarini olish",
    receivingAdviceDate: 'Maslahat olish sanasini qabul qilish',
    invoiceReference: "Hisob-fakturali ma'lumotnomasi",
    taxSerialNumber: 'Soliq seriyasining raqami',
    vatAmount: 'QQS miqdori',
    totalAmount: 'Umumiy hisob',
    order: 'Tartib',
    billingStatement: "To'lov hisob bayonoti",
    quote: 'Sitata( iqtibos)',
    receivingAdvice: 'Maslahat olish',
    despacthAdviceReference: "Jo'natish maslahat ma'lumotnomasi",
    organizationSales: 'Tashkilot savdosi',
    area: 'Hudud ',
    salesDetail: 'Savdo tafsilotlari',
    oneTimePassword: 'Bir martalik parol',
    pleaseEnterYourReceiveCode: 'Iltimos, qabul kodini kiriting',
    enterReceiveCode: 'Kodni kiriting',
    enableOTP: 'Bir martalik kodni yoqish',
    sendCode: 'Kodni yuborish',
    indonesian: 'Indonez tili',
    english: 'Inglizcha',
    uzbekistan: "O'zbekiston",
    russian: 'ruscha',
    roleSelection: 'Rol tanlash',
    userSelection: 'Foydalanuvchi tanlovi',
    taskName: 'Vazifa nomi',
    shippingLetter: 'Yuk tashish xati',
    senderContact: 'Yuboruvchi kontakti',
    street: "Ko'cha",
    restrictions: 'Cheklovlar',
    senderTelephone: 'Yuboruvchi telefoni',
    warehouse: 'Ombor',
    shippingNumber: 'Yuk tashish raqami',
    shippingDate: 'Yuk tashish sanasi',
    receiverContact: 'Qabul qiluvchi kontakti',
    receiverTelephone: 'Qabul qiluvchi telefoni',
    totalColie: 'Jami Coli',
    uploadAttachment: 'Ilovani yuklash',
    register: "Ro'yxatga olmoq",
    registerText: 'Hisob qaydnomangizni yarating',
    createAccount: 'Hisob yaratish',
    quoteReference: "Iqtibos ma'lumotnomasi",
    quoteCurrency: 'Sitata( iqtibos) valyutasi',
    quoteDate: 'Iqtibos sanasi',
    orderCurrency: 'Buyurtma valyutasi',
    fileName: 'Fayl nomi',
    requestQuantity: 'Savollar miqdori',
    invoiceDate: 'Hisob-faktura sanasi',
    sender: "Jo'natuvchi",
    organizationParent: 'Ota-onalar tashkiloti',
    grandTotal: 'Jami',
    parentCompany: 'Ota-onalar kompaniyasi',
    documentTypeStatus: 'Turi va hujjat holati',
    assetTypeStatus: 'Aktiv turi va holati',
    lineItemRevision: "Satr elementini qayta ko'rib chiqish",
    assetStatus: 'aktiv holati',
    backToLoginPage: 'Kirish sahifasiga qaytish',
    virtualAccountNumber: 'Virtual hisob raqami',
    remark: 'Izoh',
    printPdf: 'PDF-ni bosib chiqarish',
    registrationNumber: "Ro'yxatdan o'tish raqami",
    details: 'Tafsilotlar',
    configProperty: 'Mulk',
    configValue: 'Qiymat',
    accountType: 'Hisob turi',
    accountNumber: 'Hisob raqami',
    showRelativeTime: "Nisbiy vaqtni ko'rsating",
    showDocumentRead: "Hujjatni o'qish holatini ko'rsatish",
    funderRequiredAccountTypes: 'Moliyalashtiruvchi hisob qaydnomasi turi',
    buyerRequiredAccountTypes: 'Xaridor hisob qaydnomasi turi',
    sellerRequiredAccountTypes: 'Sotuvchi hisob qaydnomasi turi',
    financialRequest: "Moliyaviy so'rov",
    paymentId: "To'lov identifikatori",
    financingTenor: 'Moliyalashtirish muddati',
    calculationStartDate: 'Hisoblashning boshlanish sanasi',
    maximumFinancingTenor: 'Maksimal moliyalashtirish muddati',
    interestRate: 'Stavka foizi',
    commissionAmount: 'Komissiya miqdori',
    total: 'Jami',
    financialInformation: "Moliyaviy ma'lumotlar",
    whtinterstRate: "Daromat solig'I stavkasi",
    interestAmount: 'Foizlar miqdori',
    requestDate: 'Buyurtma sanasi',
    customerType: 'Mijoz turi',
    about: 'Haqida',
    interestIndex: 'Foizlar indeksi',
    contactUs: "Biz bilan bog'lanish",
    download: 'Yuklab olish',
    uploadAccurate: 'Aniq yuklash',
    sales: 'Savdo',
    approvalMatrix: 'Tasdiqlash matritsasi',
    approvalMatrixList: "Tasdiqlash matritsasi ro'yxati",
    approvalMatrixDetail: 'Tasdiqlash Matrix tafsilotlari',
    productMaintenance: "Mahsulotga texnik xizmat ko'rsatish",
    itemDescription: "Ma'lumotlar tavsifi",
    size: "O'lcham",
    priceList: "Narxlar ro'yxati",
    priceTier: 'Narx darajasi',
    productDetail: 'Mahsulot tafsilotlari',
    productCreate: 'Mahsulot yaratish',
    addPrice: "Narx qo'shish",
    stockValidation:
        'Sitata(iqtibos) operatsiyasini davom ettira olmaysiz, iltimos, davom etishdan oldin omboringizni tiklang',
    failedValidation: "Vazifani qayta ishlashni amalga oshirib bo'lmadi",
    levelType: "O'lchov turi",
    dateCreated: 'Yaratilish sanasi',
    maximumCreditLine: 'Maksimal kredit liniyasi',
    outstandingCredit: "To'lanmagan kredit",
    availableCreditLimit: 'Mavjud kredit limiti',
    funderName: 'Moliyalashtiruvchi nomi',
    maximumTenor: 'Maksimum muddat',
    financingPercentage: 'Moliyalashtirish foizi',
    invoiceAmount: 'Hisob-faktura miqdori',
    invoiceDiscount: 'Hisob-faktura chegirmasi',
    interestCost: 'Foiz qiymati',
    fundedAmount: 'Moliyalashtirilgan summa',
    currentTenor: 'Joriy muddat',
    assets: 'Aktivlar',
    asset: 'Aktiv',
    assetType: 'Aktiv turi',
    assetAmount: 'Aktivlar miqdori',
    originalAmount: 'Asl miqdor',
    funder: 'Moliyalashtiruvchi',
    createNew: 'Yangi yaratish',
    addLevel: "Daraja qo'shish",
    addGroup: "Guruh qo'shish",
    groupName: 'Guruh nomi',
    revisedDate: "Qayta ko'rib chiqilgan sana",
    addUser: 'Tasdiqlash',
    approverList: "Murojaatlar ro'yxati",
    revisedMessage: "Ushbu hujjatni qayta ko'rib chiqishni xohlaysizmi?",
    minimumApprover: 'Minimal tasdiqlash',
    fundingRequest: 'Moliyalashtirish bayonnomasi',
    expectedDisbursementDate: "Kutilayotgan to'lov sanasi",
    expectedSettlementDate: 'Kutilayotgan hisob-kitob sanasi',
    requestedCredit: 'Talab qilingan kredit',
    totalLimit: 'Umumiy cheklov',
    vehicleNumber: 'Avtomobil raqami',
    downPaymentReference: "Dastlabki to'lov ma'lumotnomasi",
    totalOutstanding: "Umumiy to'lanmagan ",
    totalLimitUtilization: 'Foydalanishning umumiy chegarasi ',
    referenceRate: "Ma'lumotlar darajasi",
    rateChange: `Tarifni o'zgartirish`,
    rateChangeLockStatus: `Tezlikni o'zgartirish blokirovkasi holati`,
    commissionRate: 'Komissiya darajasi',
    spread: 'Tarqatish',
    interestCalculationMethod: 'Foizlarni hisoblash usuli',
    brokerFee: "Broker to'lovi",
    othersFee: "Boshqalar uchun to'lov",
    technologyFee: "Texnologik to'lov",
    insuredPercentage: "Sug'urtalangan foiz",
    insuredAmount: "Sug'urtalangan miqdor",
    creditInsurer: "Kredit sug'urtasi",
    stage: 'Sahna',
    disbursementDate: "To'lovni talab qilish sanasi",
    eligibleAmount: 'Muvofiq miqdor',
    disbursementAmount: "To'lov miqdori",
    discountFee: "Chegirma to'lovi",
    arrearsFee: "Qarzlar to'lovi",
    lateFee: "Kechikkanlik uchun to'lovi",
    payment: "To'lov",
    feeType: "To'lov turi",
    calculationMethod: 'Hisoblash usuli',
    calculationRate: 'Hisoblash darajasi',
    calculationResult: 'Hisoblash natijasi',
    arrears: 'Qarzdorlik',
    transfer: "O'tkazish",
    settlementDate: 'Hisob-kitob sanasi',
    transferDate: "O'tkazish sanasi",
    actualDisbursementDate: "Haqiqiy to'lovlar sanasi",
    fromAccount: 'Hisobdan',
    fromAccountNumber: 'Hisob raqamidan',
    soapResponse: 'Javob',
    soapNarative: 'Hisobot',
    toAccount: 'Hisobga ',
    toAccountNumber: 'Hisob raqamiga',
    amountType: 'Miqdor turi',
    feeDetail: "To'lov tafsilotlari",
    rateChangesHistory: "Tariflarni o'zgartirish tarixi",
    feeInformation: "To'lov haqida ma'lumot",
    chargeDetail: "To'lov tafsilotlar",
    disbursement: "To'lov",
    settlement: 'Hisob-kitob',
    programName: 'Dastur nomi',
    programDescription: 'Dastur tavsifi',
    stageConfigurations: 'Sahna konfiguratsiyasi',
    stageNumber: 'Sahna raqami',
    requiredAccountTypes: 'Hisob turlari',
    insurance: "Sug'urta",
    organizationCode: 'Tashkilot kodi',
    funderSelection: 'Hamkorlik',
    funderProperty: 'Moliyalashtiruvchi mulki',
    buyerProperty: 'Xaridor mulki',
    sellerProperty: 'Sotuvchi mulki',
    dailyCharge: "Kundalik to'lovlar",
    requestStatement: 'Talab bayonnomasi',
    dateUpdated: 'Sana yangilandi',
    financialRequestReference: 'Moliyaviy talabnoma',
    documentChecking: 'Hujjatni tekshirish',
    close: 'Yaqin',
    disbursementHistory: "To'lov tarixi",
    settlementHistory: 'Hisob-kitob tarixi',
    totalDailyCharges: "Umumiy kunlik to'lovlar",
    disburseAmountValidation: "* Miqdor munosib miqdorga teng bo'lishi kerak",
    assetDate: 'Aktiv sanasi',
    assetDetail: 'Aktiv tafsilotlari',
    notifications: 'Bildirishnoma',
    loadMore: "Ko'proq yuklang!",
    repaymentAmount: "To'lov miqdori",
    remainingAmount: 'Qolgan miqdor',
    outstandingAmount: "To'lanmagan summa",
    residual: 'Qoldiq',
    residualTransferDate: "Qoldiqni o'tkazish sanasi",
    settlementBookingDate: 'Hisob-kitoblarni bron qilish sanasi',
    actualSettlementDate: 'Haqiqiy hisob-kitob sanasi',
    processedDocument: 'Moliyalashtirish bayonnomasi',
    settlementAmount: 'Hisob-kitob miqdori',
    loginContactUs: "Yordam kerakmi? Biz bilan bog'laning !",
    assetCreationDate: 'Aktiv yaratish sanasi',
    percentage: 'Foiz',
    automatic: 'Avtomatik',
    suspend: "To'xtatmoq",
    noConfigurations: "Konfiguratsiya qo'shilmagan.",
    financialOrganization: 'Moliyaviy tashkilot',
    addFinancialOrganization: "Moliyaviy tashkilot qo'shish",
    editFinancialOrganization: 'Moliyaviy tashkilot tahrirlash',
    accountName: 'Hisob nomi',
    bankCode: 'Bank kodi',
    branch: 'Filial',
    branchName: 'Filial nomi',
    bankName: 'Bank nomi',
    bankAddress: 'Bank manzili',
    swiftCode: 'Butunjahon banklararo moliyaviy telekommunikatsiya jamiyati kodi',
    bankDetails: 'Bank tafsilotlari',
    addNew: "Yangi qo'shing",
    approvalConfirm: 'Iltimos, tasdiqni tasdiqlang',
    whtInterest: "Daromat solig'i stavkasi",
    whtInterestAmount: "Daromat solig'i stavkasi miqdori",
    whtProcessingFee: "Daromat solig'i to'lovi",
    whtProcessingFeeAmount: "Daromat solig'i to'lovi miqdori",
    processingFee: "qayta ishlov to'lovi",
    totalDisbursementAmount: "Umumiy to'lovlar miqdori",
    rate: 'Baholash',
    method: 'Usul',
    interest: 'Foyda',
    arrears_on_settlement: "Hisob-kitob bo'yicha qarzlar",
    bankCharge: "Bank to'lovi",
    methods: 'Usullar',
    disbursementMode: "To'lov rejimi",
    cost: 'Narx',
    forms: 'Shakllar',
    maximumAmount: 'Maksimal miqdor',
    property: 'Mulk',
    totalCharge: "Umumiy to'lov",
    extensionSetting: 'Kengaytma sozlamalari',
    penaltyEnabled: 'Jazo yoqilgan',
    extensionInterest: 'Kengaytma foydasi',
    penaltyGracePeriod: 'Penalti infrating davri',
    cycle: 'Penaltining tsikli',
    penaltyInterest: 'Jinoyat qiziqishi',
    freeze: 'Muzlamoq',
    days: 'Kunlar',
    interestOnPenalty: 'Jinoyat foizlari',
    arrearsFeeAfterDueDate: "Muddati tugagandan keyin qarzdorlik to'lovi",
    dailyChecking: 'Kundalik tekshirish',
    addPenaltyInterest: "Qo'shmoq",
    penalty: 'Jarima',
    addPenalty: "Penaltini qo'shing",
    extend: "Cho'zmoq",
    maximumExtendedTenor: 'Maksimal kengaytirilgan tenor',
    extensionDate: 'Kengaytirilgan sana',
    limitContractSetting: 'Shartnomani cheklash',
    maximumCreditLimit: 'Maksimal kredit limiti',
    overridePercentage: 'Foizni bekor qilish',
    assetPercentage: 'Aktiv foizi',
    fundingPercentage: 'Moliyalashtirish foizi',
    activationSetting: 'Faollashtirish sozlamalari',
    overrideAmount: 'Miqdorini bekor qilish',
    enabled: 'Yoqilgan',
    litigation: 'Sud jarayoni',
    proformaInvoice: 'Dastlabki hisob',
    flowConfigurations: 'Oqim konfiguratsiyalari',
    programType: 'Dastur turi',
    flowPreview: "Oqimni oldindan ko'rish",
    propertySetting: 'Mulkni sozlash',
    inventoryChecking: 'Inventarizatsiya tekshiruvi',
    partlyDespatchAdvice: 'Qisman desptch maslahat',
    uploadInvoices: 'Yuklovchilarni yuklash',
    uploadInventory: 'Yuklarni yuklash',
    uploadProduct: 'Mahsulotni yuklang',
    shippingInformation: "Yuk tashish ma'lumotlari",
    participantInformation: "Ishtirokchilar haqida ma'lumot",
    otherInformation: "Boshqa ma'lumotlar",
    incoTerm: 'Dudrat',
    product: 'Mahsulot',
    vesselId: 'Kema identifikatori',
    billOfLadingDate: 'Yetkazib berish sanasi',
    createOrder: 'Buyurtma yaratish',
    item: 'Buyum',
    balanceStock: 'Muvozanat',
    valueUpdate: 'Qiymatni yangilash',
    updateStock: 'Yangilash fondini yangilang',
    invoiceCurrency: 'Hisob-faktura valyutasi',
    invoiceNumber: 'Hisob-faktura raqami',
    incoterm: 'Nizo',
    invoiceLineItem: "Hisob-faktura chizig'i",
    loadPort: 'Yuklash porti',
    dischargePort: 'Oqindi port',
    daysDivisorTitle: 'Kunlar soni Sivilovchi',
    divisor: "Bo'linuvchi",
    uploadOrder: 'Buyurtmani yuklash',
    noAction: "Hech qanday harakat yo'q",
    despatchGoodsConfirmation: 'Tovarlarni tasdiqlash',
    despatchAdviceDate: 'Dispatch Maslahat sanasi',
    proformaInvoiceReference: "Proformat fakturasi ma'lumotnomasi",
    proformaInvoiceDate: 'Proforma schyot-faktura sanasi',
    buyerContactPhone: 'Xaridor bilan aloqa telefoni',
    sellerContactPhone: 'Sotuvchi aloqa telefoni',
    buyerAccountNumber: 'Xaridor hisob raqami',
    sellerAccountNumber: 'Sotuvchi hisob raqami',
    actualWaterContent: 'Haqiqiy suv tarkibi',
    waterContentReduction: 'Raflashtirish',
    proposalRejectionDays: 'Reklama rad javoblari',
    cutOffTime: 'Vaqtni kesib oling (HH: mm: SS)',
    minimumFinancingTenor: 'Minimal moliyalashtirish tenor',
    maximumPassDueDate: "Maksimal o'tish muddati",
    buyerRecourse: 'Xaridor murojaat',
    buyerSetting: 'Xaridor sozlamalari',
    sellerRecourse: 'Sotuvchi murojaat',
    sellerSetting: 'Sotuvchi sozlamalari',
    residuals: 'Qoldiqlar',
    assetSettlement: 'Aktivlarning aholi punkti',
    repaymentDate: "To'lov muddati",
    dilutions: 'Silms',
    manualSettlement: "Qo'llanma",
    assetNumber: 'Aktiv raqami',
    settle: 'Hal qilmoq',
    dilution: 'Suyultirish',
    remarks: 'Izohlar',
    generalLedger: 'Umumiy Buxgalteriya',
    invoicePurchased: 'Faktura sotib olingan',
    documentList: "Hujjatlar ro'yxati",
    accountPayable: "Hisobni to'lash kerak",
    disbursementTransferApproval: 'DSibosementni topshirish',
    settlementTransferApproval: 'Hisob-kitobni uzatish',
    bankGlNumber: 'Bank gl raqami',
    sdReceipt: 'SD kvitansiyasi',
    interestIncome: 'Foizli daromad',
    penaltyInterestIncome: 'Jarima foizli daromad',
    processingFeeIncome: "Qayta ishlash bo'yicha daromadlar",
    bankCharges: "Bank to'lovlari",
    accountReceivables: 'Hisobni debitorlik qarzlari',
    vatCode: 'QQS kodi',
    disbursementApproval: 'Chet ellashtirishni tasdiqlash',
    attachmentList: "Ilovalar ro'yxati",
    lineItemNoData: "Ma'lumot topilmadi.",
    loading: 'Qayta ishlash ...',
    start: 'Boshlamoq',
    prepaidAmount: "Oldindan to'langan summa",
    downPayment: "Ilk to'lov",
    scheduler: 'Reja',
    fscm: "Moliyaviy ta'minot zanjiri menejmenti",
    pleaseSignIn: 'Iltimos, tizimga kiring',
    convergenceTag1: "Innovatsion moliyalashtirish echimlarini ta'minlash,",
    convergenceTag2:
        "Shunday qilib, siz o'z biznesingizni o'stirishingizga e'tibor qaratishingiz mumkin.",
    taskEditDocumentMessage: 'Hujjat muvaffaqiyatli tahrirlangan.',
    rejectionRemark: 'Rad etish',
    priceCorrection: 'Narxlarni tuzatish',
    overdueDays: 'Kechiktirilgan kunlar',
    creditRating: 'Kredit reytingi',
    allowFinance: 'Hisob-fakturadan',
    invoiceRecalculate: '* Hujjat saqlangandan keyin miqdor qayta hisoblab olinadi.',
    qualityAnalysisResult: 'Sifatni tahlil qilish natijalari',
    testQuality: 'Rays vujudga kelish natijalari',
    standardText: 'Standart',
    notStandardText: "Shunga ko'ra standart emas",
    clearSelection: 'Tanlovni tozalash',
    receivedQuantityChecking: 'Olingan miqdorni tekshirish',
    discountApproval: 'Chegirma tasdiqlash',
    serviceProviderApproval: "Xizmat ko'rsatuvchi provayder tasdiqlash",
    relatedAttachmentList: "Tegishli biriktirma ro'yxati",
    jobManagement: 'Ishni boshqarish',
    JobScheduler: 'Ish jadvali',
    JobSchedulerTrigger: 'Ish jadvali TRIGGER',
    JobExecutionDetails: 'Ishni bajarish tafsilotlari',
    jobName: 'Ish nomi',
    lastRunTime: 'Oxirgi ish vaqti',
    nextRunTime: 'Keyingi ish vaqti',
    lastResult: 'Oxirgi natija',
    approval: 'Tasdiqlash',
    JobSchedulers: 'Ish jadvallari',
    JobExecutions: 'Ish qatlamlari',
    jobInstances: 'Ish holatlari',
    calendarName: 'Taqvim nomi',
    cronExpression: 'Cronf',
    activeContract: 'Faol shartnoma',
    jobActiveEntity: 'Ish faol subyekt',
    jobPerspective: 'Ish istiqbollari',
    state: 'Davlat',
    addTrigger: "TRIGGER qo'shing",
    enable: 'Yoqish',
    disable: "O'chirmoq",
    referenceSource: "Manzil manbai qo'shilgan",
    'No Data Available': 'Maʼlumotlar mavjud emas',
    'com.asyx.x4.user.nofill': "Iltimos, ma'lumotlarni to'ldiring",
    'com.asyx.x4.user.onlyAlphanumeric_username': "Foydalanuvchi nomi noto'g'ri",
    'com.asyx.x4.user.maximumCharacter_username': "Foydalanuvchi nomi noto'g'ri",
    'com.asyx.x4.user.onlyAlphabetic_name': "Ism noto'g'ri",
    'com.asyx.x4.user.manimumCharacter_name': "Ism noto'g'ri",
    'com.asyx.x4.user.invalidFormat_email': "Elektron pochta manzili noto'g'ri",
    'com.asyx.x4.user.maximumCharacter_email': "Elektron pochta manzili noto'g'ri",
    'com.asyx.x4.user.onlyNumeric_mobileNumber': "Mobil raqam noto'g'ri",
    'com.asyx.x4.user.minimumCharacter_mobileNumber': "Mobil raqam noto'g'ri",
    'com.asyx.x4.user.weak_password': "Parol noto'g'ri",
    'com.asyx.x4.user.nofill_username': "Iltimos, foydalanuvchi nomini to'ldiring",
    'com.asyx.x4.user.nofill_name': "Iltimos ismni to'ldiring",
    'com.asyx.x4.user.nofill_email': "Iltimos, elektron pochta manzilini to'ldiring",
    'com.asyx.x4.user.nofill_mobileNumber': "Iltimos, mobil raqamni to'ldiring",
    'com.asyx.x4.user.nofill_password': "Iltimos, parolni to'ldiring",
    'com.asyx.x4.date.nofill': 'Iltimos, sanani tanlang',
    'com.asyx.x4.calandar.nofill_name': "Iltimos ismni to'ldiring",
    'com.asyx.x4.authorization.user-role_nofill':
        'Iltimos, foydalanuvchi hisobini va rolni tanlang',
    'com.asyx.x4.authorization.role_nofill': 'Iltimos, rolni tanlang',
    'com.asyx.x4.authorization.user_nofill': 'Foydalanuvchi qayd yozuvini tanlang',
    'com.asyx.x4.organization.nofill_reference': "Ma'lumotnomada qiymat bo'lishi kerak",
    'com.asyx.x4.organization.onlyAlphanumeric_reference': "Ma'lumot noto'g'ri",
    'com.asyx.x4.organization.max_reference': "Ma'lumot noto'g'ri",
    'com.asyx.x4.organization.nofill_fullname': "To'liq ism qiymat bo'lishi kerak",
    'com.asyx.x4.organization.max_fullname': "To'liq ism noto'g'ri",
    'com.asyx.x4.organization.nofill_contactPerson':
        "Aloqa qiluvchi shaxs qiymatni o'z ichiga olishi kerak",
    'com.asyx.x4.organization.onlyAlphanumeric_contactPerson': 'Aloqa qiluvchi shaxs yaroqsiz',
    'com.asyx.x4.organization.max_contactPerson': 'Aloqa qiluvchi shaxs yaroqsiz',
    'com.asyx.x4.organization.nofill_email':
        "Bog'lanuvchi elektron pochta manzilini o'z ichiga olishi kerak",
    'com.asyx.x4.organization.invalidFormat_email': "Bog'lanuvchi elektron pochtasi noto'g'ri",
    'com.asyx.x4.organization.max_email': "Bog'lanuvchi elektron pochtasi noto'g'ri",
    'com.asyx.x4.organization.nofill_contactPersonPhone':
        "Bog'lanuvchi telefonida qiymat bo'lishi kerak",
    'com.asyx.x4.organization.onlyAlphanumeric_contactPersonPhone':
        "Bog'lanuvchi telefoni noto'g'ri",
    'com.asyx.x4.organization.max_contactPersonPhone': "Bog'lanuvchi telefoni noto'g'ri",
    'com.asyx.x4.organization.nofill_city': "Shaharda qiymat bo'lishi kerak",
    'com.asyx.x4.organization.max_city': 'Shahar yaroqsiz',
    'com.asyx.x4.organization.nofill_timeZone': "Vaqt zimmasiga ega bo'lishi kerak",
    'com.asyx.x4.organization.nofill_country': "Mamlakatda qiymat bo'lishi kerak",
    'com.asyx.x4.organization.max_country': "Mamlakat noto'g'ri",
    'com.asyx.x4.organization.nofill_address1': "Manzilni o'z ichiga olishi kerak",
    'com.asyx.x4.organization.max_address1': "Manzil noto'g'ri",
    'com.asyx.x4.organization.nofill_contactPersonDepartment':
        "Bog'lanuvchi bo'limida qiymat bo'lishi kerak",
    'com.asyx.x4.organization.onlyAlphabetic_contactPersonDepartment':
        "Bog'lanuvchi bo'limi noto'g'ri",
    'com.asyx.x4.organization.max_contactPersonDepartment': "Bog'lanuvchi bo'limi noto'g'ri",
    'com.asyx.x4.document.between5to50_refrence': "Ma'lumot uzunligi 5 dan 50 gacha bo'lishi kerak",
    'com.asyx.x4.invoice.mustPositive_amount': "Miqdorda ijobiy qiymat bo'lishi kerak",
    'com.asyx.x4.document.nofill_currency': 'Iltimos, valyutani tanlang',
    'com.asyx.x4.invoice.nofill_buyerSeller':
        "Xaridor nomi va sotuvchi nomi qiymatni o'z ichiga olishi kerak!",
    'com.asyx.x4.invoice.nofill_amount': "Umumiy miqdorda qiymat bo'lishi kerak!",
    'com.asyx.x4.invoice.nofill_invoiceReference':
        "Hisob-faktura raqami biron bir qiymatni o'z ichiga olishi kerak!",
    'com.asyx.x4.invoice.nofill_invoiceDate': "Hisob-faktura sanasida qiymat bo'lishi kerak!",
    'com.asyx.x4.invoice.nofill_maturityDate': "Eskirish qiymati bo'lishi kerak",
    'com.asyx.x4.invoice.nofill_billOfLadingDate': "Bill Bill qiymatini o'z ichiga olishi kerak!",
    'com.asyx.x4.finprocess.statement.router.credit_limit_exceeded':
        "Moliyalashtirish to'g'risidagi ariza ishtirokchi chegarasidan oshdi",
    'com.asyx.x4.finprocess.statement.router.credit_limit_contract_exceeded':
        'Moliyalashtirish bayonnomasi shartnoma chegarasidan oshdi',
    'com.asyx.x4.finprocess.statement.router.requestor_suspend':
        "Talab to'xtatildi. Iltimos, yangi moliyalashtirishni talab qilish uchun mavjud bo'lgan muddati o'tgan so'nggi bitimlarni hal qiling.",
    'com.asyx.x4.contract.used_in_transaction':
        "Shartnomani boshqa bitimlar (lar) bilan o'chirib tashlamagan.",
    'com.asyx.x4.error.unknown': "Noma'lum xato yuz berdi, keyinroq qayta urinib ko'ring.",
    'com.asyx.x4.error.network':
        "Serverga ulanib bo'lmadi, iltimos, Internetga ulanishingizni tekshiring.",
    'com.asyx.x4.document.between1to15_vehicleNumber':
        'Panjang Nomor Kendrayan Maksumial 15 raqamli',
    deleteProgramConfirmation: "Siz dasturni o'chirishni xohlayotganingizga ishonchingiz komilmi?",
    cantUndo: 'Buni bekor qila olmaysiz.',
    noPermissionDocumentView: "Sizda ushbu hujjatga kirish huquqi yo'q.",
    noDataFound: "Ma'lumot topilmadi.",
    'b2b.documentDetail': 'Hujjat tafsilotlari',
    'b2b.orderTo': 'Uchun buyurtma',
    'b2b.shipTo': 'Ga yetkazib berish',
    'b2b.orderInformation': "Buyurtma haqida ma'lumot",
    'b2b.poStatus': 'PO holati',
    'b2b.poDate': 'PO sanasi',
    'b2b.poExpiredDate': "Muddati o'tgan sana",
    'b2b.poType': 'PO turi',
    'b2b.partialDelivery': 'Qisman yetkazib berish',
    'b2b.top': 'Eng yuqori',
    'b2b.productName': 'Mahsulot nomi',
    'b2b.quantity': 'Miqdori',
    'b2b.price': 'Donasining narxi',
    'b2b.items': 'Narsalar',
    'b2b.discount': 'Chegirma miqdori',
    'b2b.discountAmount': 'Chegirma miqdori',
    'b2b.luxuryTax': 'Hashamat soliq',
    'b2b.totalPoAmount': 'Jami sotib olishga buyurtma miqdori',
    'b2b.subtotal': 'Umumiy',
    'b2b.subTotalAfterDiscount': 'Chegirmadan keyin',
    'b2b.npwp': 'Ro‘yxatdan o‘tish raqam',
    'b2b.telp': 'Telefon raqam',
    'b2b.attn': 'Diqqat',
    'b2b.fax': 'Faks',
    'b2b.customerInformation': "Mijoz haqida ma'lumot",
    'b2b.billingInformation': "To'lov ma'lumotlari",
    docstoreRole: 'Tashkilot roli',
    'b2b.customer': 'Xaridor',
    volume: 'Hajmi',
    fixedPrice: 'Statsionar narx',
    shortName: 'Qisqa ism',
    validFrom: 'Yaroqsiz',
    minimumAmount: 'Minimal miqdor',
    taxable: 'Soliqqa tortiladigan',
    priceTiers: 'Narxlar',
    assignedEntities: 'Tayinlangan tashkilotlar',
    'b2b.yes': 'Ha',
    'b2b.no': "Yo'q",
    editPrice: 'Narxlarni tahrirlash',
    priceDetail: 'Narxlar tafsilotlari',
    pricingRules: 'Narxlar qoidalari',
    processVariable: "Jarayon o'zgaruvchisi",
    'com.b2b.shortName.isNull': 'Qisqa ism talab qilinadi.',
    'com.b2b.validFrom.isNull': 'Yaroqliligi talab qilinadi.',
    'com.b2b.discount.isNull': 'Chegirma talab qilinadi.',
    'com.b2b.minimumAmount.isNull': 'Minimal miqdor talab qilinadi.',
    'com.b2b.amount.isNull': 'Miqdor talab qilinadi.',
    'com.b2b.priceTiers.isEmpty': "Minimal 1 ta narx darajasiga ega bo'lishi kerak.",
    'com.b2b.priceTier.volume.isEmpty': "Narxi steridagi hajmi bo'sh bo'lishi mumkin emas.",
    'com.b2b.priceTier.fixedPrice.isEmpty':
        "Narxi starti bo'yicha belgilangan narx bo'sh bo'lishi mumkin emas.",
    'com.b2b.priceTier.percentage.isEmpty': "Narxi staryeni foizi bo'sh bo'lishi mumkin emas.",
    'com.b2b.priceTier.processVariable.isEmpty':
        "Narxier staryatsiyasida qayta ishlash o'zgaruvchisi bo'sh bo'lishi mumkin emas.",
    priceMaintenance: 'Narxlarni saqlash',
    countryISOCode: 'Mamlakat ISO kodi',
    faxNumber: 'Faks raqami',
    customerName: 'Mijoz nomi',
    settleOrRevise: "Joylash yoki qayta ko'rib chiqish",
    billingStatements: "Billing ma'lumotlari",
    customer: 'Xaridor',
    registrationNo: "Ro'yxatdan o'tish raqami",
    revision: "Qayta ko'rib chiqish",
    statementDate: 'Bayonnoma sanasi',
    minimumFee: "Minimal to'lov",
    specification: 'Spetsifikatsiya',
    valueAddedTax: "Qo'shilgan qiymat solig'i (QQS)",
    requestedDisbursementDate: "So'ragan to'lov sanasi",
    requestedSettlementDate: 'Talab qilingan hisob-kitob sanasi',
    signature: 'Imzo',
    signatureSender: 'Yuboruvchi:',
    signatureReceiver: 'Qabul qilgich:',
    signatureDate: 'Sana:',
    signatureApproved: 'Tasdiqlangan: direktor kengashi',
    addressOne: 'Birinchi manzil',
    addressTwo: 'Ikkinchi manzil',
    'com.asyx.x4.user.password_missmatch': 'Joriy parol mos emas',
    'com.asyx.x4.uoa.updatepassword.invalid_length':
        'Parolingiz kamida 9 ta belgidan iborat boʻlishi kerak',
    'com.asyx.x4.uoa.updatepassword.no_symbol': "Parolingizda belgi bo'lishi kerak",
    'com.asyx.x4.uoa.updatepassword.no_number': "Sizning parolingiz tarkibida raqam bo'lishi shart",
    'com.asyx.x4.uoa.updatepassword.no_upper_case':
        "Parolingiz katta harflardan iborat bo'lishi kerak",
    'com.asyx.x4.uoa.updatepassword.no_lower_case':
        "Parolingiz kichik harflardan iborat bo'lishi kerak",
    'com.asyx.x4.uoa.updatepassword.contain_space': 'Parolingizda boʻsh joy boʻlmasligi kerak',
    'com.asyx.x4.uoa.updatepassword.contain_symbol_number':
        "Parolingizda belgi va raqam bo'lishi kerak.",
    'com.asyx.x4.uoa.updatepassword.symbol_number_upper':
        "Parolingizda belgi, raqam va katta harf bo'lishi kerak",
    'com.asyx.x4.uoa.updatepassword.symbol_number_lower':
        "Parolingizda belgi, raqam va kichik harf bo'lishi kerak",
    'resetPassword.maximumAttempt': "Juda ko'p urinishlar. (Kuniga 3 marta)",
    'com.asyx.x4.user.password_has_been_used':
        'Bu parol avval ham ishlatilgan. Iltimos, yangi parol tanlang.',
    confirmPassword: 'Parolni tasdiqlang',
    passwordResetSuccess: "Parol yangilangan, tizimga kirish sahifasiga yo'naltirish",
    orClick: 'yoki bosish',
    here: 'Bu yerga',
    showUploadProductTips:
        "Katta mahsulotlar ro'yxatini ro'yxatdan o'tkazish uchun fayllarni kiritishingiz mumkin",
    thisPage: 'Ushbu sahifa',
    dontRemind: 'Eslatmang',
    goToLoginPage: 'hozir boshlash',
    signatureName: 'Ism:',
    transferAfterGR: "Yaxshi qabul qilingandan keyin pul o'tkazish",
    transferAfterQualityApproval: "Sifatni tasdiqlashdan keyin o'tkazing",
    transferAfterGRValidation:
        "Yaxshi qabul qilinganidan keyin pul o'tkazish qiymati bo'lishi kerak.",
    transferAfterQualityApprovalValidation:
        "Sifatli tasdiqlashdan keyin pul o'tkazish qiymati bo'lishi kerak",
    'Apr On Asset Amount': 'Aktiv miqdorida',
    'Apr On Disbursement Amount': 'YANGILIKLARNING APR',
    'Apr On Eligible Amount': 'Ipl3',
    'Apr On Original Amount': 'Asl miqdorda',
    'Percentage Of Asset Amount': 'aktivlarning% miqdori',
    'Percentage Of Disbursement Amount': 'Chet etish summasining%',
    'Percentage Of Eligible Amount': 'Muvofiq miqdorning%',
    'Percentage Of Original Amount': '% ning% miqdori',
    'Arrears On Settlement': "Hisob-kitob bo'yicha qarzlar",
    exportPdf: 'PDF-ni yuboring',
    exportCsv: 'CSV-ni yuboring',
    exportExcel: 'XLS-ni yuboring',
    exportXml: 'XML-ni yuboring',
    exportMt940: 'MT940-ni yuboring',
    exportProcessingMessage: 'Biz sizning faylingizni qayta ishlamoqdamiz, iltimos, kuting ...',
    accountEnabled: 'Hisob yoqilgan',
    accountDisabled: "Hisob o'chirilgan",
    accountLocked: 'Hisob yopilgan',
    accountUnlocked: 'Hisob ochilgan',
    unlockAccount: 'Hisobni qulfdan chiqarish',
    showMore: "Ko'proq ma'lumot ...",
    showMoredata: "Ko'proq ko'rsatish",
    showLessdata: "Kamroq ko'rsatish",
    viewJobExecution: 'Natijani ko’rish',
    apmsReference: "Samaradorlikni avtomatlashtirilgan o'lchash tizimi ",
    viewJobInstances: 'Na’munalarni ko’rish',
    totalPO: 'Buyurtma soni',
    percentage_of_asset_amount: 'aktivlarning% miqdori',
    percentage_of_disbursement_amount: "To'lov miqdorining %",
    percentage_of_eligible_amount: 'Muvofiq miqdorning %',
    percentage_of_original_amount: 'Haqiqiy miqdorining %',
    apr_of_asset_amount: 'Aktiv summasining yillik foiz stavkasi',
    apr_of_disbursement_amount: "To'lov summasining yillik foiz stavkasi",
    apr_of_eligible_amount: 'Kerakli miqdorning yillik foiz stavkasi',
    apr_of_original_amount: 'Asl miqdorning yillik foiz stavkasi',
    apr_of_remaining_disbursement_amount: "Qolgan summasining to'lovning yillik qiymati",
    calculationTypeValue: 'Tur',
    calculationType: 'Hisoblash turi',
    penaltyCalculationType: 'Jarimani hisoblash turi',
    signatures: 'Imzolar',
    principalAmount: 'Asosiy qarz miqdori',
    exportXml: 'XML eksport qiling',
    'hover.accept.disbursement_approval':
        "Ushbu tugmani bosganingizda Moliyaviy hisobot to'lanadi.",
    'hover.accept.asset_financing_funder_approval':
        "To'lovni to'lash bo'yicha hisobotni moliyalashtirish hujjatini davom ettirish uchun ushbu tugmani bosing.",
    'hover.accept.asset_financing_requester_approval':
        "Xizmat ko'rsatuvchi provayder yoki moliyalashtiruvchiga yuborish uchun ushbu tugmani bosing.",
    'hover.accept.service_provider_approval':
        "Moliyalashtirish to'g'risidagi bayonot hujjatini davom ettirishni tasdiqlash uchun ushbu tugmani bosing.",
    'hover.reject.disbursement_approval':
        "Tadqiqotni rad etish va moliyalashtirish to'g'risidagi hujjat to'liq rad etilishi kerak. Rad etilganda, sotuvchi kelajakda yangi so'rovni boshlashi kerak.",
    'hover.reject.asset_financing_funder_approval':
        "Ushbu tugmachani bosing. Ushbu tugma moliyalashtirish bayonnomasini rad etadi. Rad etilganda, sotuvchi kelajakda yangi so'rovni boshlashi kerak.",
    'hover.reject.service_provider_approval':
        "Ushbu tugmachani bosing. Ushbu tugma moliyalashtirish bayonnomasini rad etadi. Rad etilganda, sotuvchi kelajakda yangi so'rovni boshlashi kerak.",
    'hover.cancel.asset_financing_requester_approval':
        'Ushbu tugmachani bosish moliyalashtirish bayonnomasida bekor qiladi.',
    'hover.edit.service_provider_approval':
        "Moliyalashtirish to'g'risidagi hujjatga qo'shimcha hujjatlarini biriktirish uchun ushbu tugmani bosing.",
    'hover.edit.asset_financing_requester_approval':
        "Moliyalashtirish to'g'risidagi hujjatni o'zgartirish uchun ushbu tugmani bosing.",
    'hover.revise.disbursement_approval':
        "Ushbu tugmachani bosing va moliyalashtirish bayonnomasi qayta ko'rib chiqish uchun qayta yuboriladi.",
    update: 'Yangilamoq',
    settlementForm: 'Hisob-kitob shakli',
    attachFiles: 'Fayllarni biriktiring',
    chooseFile: 'Faylni tanlang',
    settlementConfirmation: 'Hisob-kitobni tasdiqlash',
    attachments: "Qo'shimchalar",
    createCreditNote: 'Kredit eslatmasini yarating',
    creditNote: 'Kredit eslatmasi',
    beginingOfInvoiceAmount: 'Hisob-fakturaning boshlanish miqdori',
    endingOfInvoiceAmount: 'Hisob-fakturaning tugashi',
    creditNoteAmount: 'Kredit miqdori',
    history: 'Tarix',
    loggingIn: 'Tizimga kirish ...',
    updatePassword: 'Parolni yangilang',
    enterCurrentPassword: 'Iltimos, joriy parolingizni kiriting',
    enterNewPassword: 'Iltimos, yangi parolingizni kiriting',
    generalErrorMessage:
        "Nimadir noto'g'ri ketdi, iltimos, qo'shimcha yordam so'rab qo'llab-quvvatlash markazimizga murojaat qiling.",
    too_many_attempt: `Parol 3 marta yuborildi, iltimos, keyingi kungacha kuting yoki Asyx qo'llab-quvvatlash xizmatiga murojaat qiling.`,
    assign: 'Tayinlamoq',
    editCreditNoteAmount: 'Kredit miqdorini tahrirlash',
    assignCreditNote: 'Kredit yozuvini tayinlang',
    totalTenor: 'Umumiy tenor',
    assignInvoice: 'Hisob-fakturani foydalanish huquqi',
    selectInvoice: 'Hisob-fakturani tanlang',
    interestIndexManagement: 'Foizlarni boshqarish',
    lastUpdate: "So'nggi yangilanish",
    interestIndexDetail: 'Foizlar indeksi tafsiloti',
    interestIndexEdit: 'Foizlar indeksi',
    InterestIndexAdd: "Foiz indeksi qo'shing",
    notificationTemplate: 'Xabarnoma shabloni',
    fromDate: 'Sanadan',
    toDate: 'Hozirgi kungacha',
    rateUpdates: "Ta'rif yangilanishlari",
    reconciliation: 'Kelishuv',
    reconciliationAmount: 'Kelishuv miqdori',
    otherCharges: "Boshqa to'lovlar",
    additionalReimbursement: "Qo'shimcha qoplash",
    difference: 'Farq',
    reconcile: 'Kelishmoq',
    reconciliationForm: 'Kelishuv shakli',
    confirm: 'Tasdiqlamoq',
    'com.asyx.x4.reconciliation.nofill_buyer': 'Iltimos, kamida 1 sotib oluvchini tanlang.',
    'com.asyx.x4.reconciliation.nofill_currencies': 'Iltimos, kamida 1 valyutani tanlang.',
    'com.asyx.x4.reconciliation.nofill_repaymentDate': "To'lov muddati to'ldirilishi kerak.",
    'com.asyx.x4.reconciliation.invalid_repayment_amount':
        "To'lov summasi bo'sh bo'lishi mumkin emas.",
    'com.asyx.x4.reconciliation.invalid_difference_amount': "Farq nol bo'lishi kerak.",
    'com.asyx.x4.finconfig.referencesource.service.duplicate_combination_name_and_configuration':
        'Ism va konfiguratsiya allaqachon ishlatilgan.',
    'com.asyx.x4.finconfig.referencesource.service.duplicate_combination_name_and_days':
        'Konfiguratsiya va kunlar allaqachon ishlatilgan.',
    'Too many attempt': `Parol 3 marta yuborildi, iltimos, keyingi kungacha kuting yoki Asyx qo'llab-quvvatlash xizmatiga murojaat qiling.`,
    buyerReference: "Sotib oluvchi ma'lumotnomasi",
    sellerReference: "Sotuvchi ma'lumotnomasi",
    creditNoteReference: "Kredit eslatmasi ma'lumotnomasi",
    switchUserType: "Foydalanuvchi turini o'zgartiring",
    selectUserType: 'Foydalanuvchi turini tanlang',
    supplier: 'Yetkazib beruvchi',
    quoteFormLoading: 'Tayyorlanayapti, iltimos, kuting ...',
    noLineItems: "Hech nima qo'shilmadi.",
    inactiveDialogTitle: 'Salom, siz hali ham shu yerdamisiz?',
    inactiveDialogMessage:
        "Profilingizdan ma'lum vaqt foydalanilmasa, avtomatik ravishda tizimdan chiqarilasiz.",
    inactiveDialogButton: 'Ha, iltimos kuting',
    tenor: 'Tenor',
    viewDetail: "Tafsilotni ko'rish",
    switchUser: "Foydalanuvchini o'zgartiring",
    totalUserSelected: 'Umumiy foydalanuvchi (lar) tanlangan:',
    totalDocumentSelected: 'Umumiy hujjatlar (lar) tanlangan:',
    cloneUser: 'Klon foydalanuvchi',
    cloneUsernameValidation: '* Foydalanuvchi ismi asl foydalanuvchidan farq qilishi kerak.',
    paymentInformation: "To'lov haqida ma'lumot",
    priceType: 'Narx turi',
    owner: 'Egasi',
    discountType: 'Chegirma turi',
    dataConfirmation: "Ma'lumotni tasdiqlash",
    dataHoverError: 'Ushbu faylda topilgan xato (lar).',
    dataHoverSuccess: 'Fayl yuklashga tayyor.',
    csvReviewErrors: 'Birinchi tuzatish kerak:',
    'com.task.validation.emptyQc': "Sifat shakli to'ldirilishi kerak.",
    'com.asyx.x4.qcvalidation.standardPercentage': "Iltimos, suv sifatini to'ldiring.",
    'com.asyx.x4.qcvalidation.seedAmount': "Iltimos, urug 'miqdorini to'ldiring.",
    'com.asyx.x4.qcvalidation.maxDirt': "Iltimos, maksimal axloqsizlikni to'ldiring.",
    'com.asyx.x4.qcvalidation.maxMushroom': "Iltimos, maksimal qo'ziqorinni to'ldiring.",
    'com.asyx.x4.qcvalidation.maxSkinContent': "Iltimos, terining maksimal miqdorini to'ldiring.",
    'com.asyx.x4.qcvalidation.notSalty': "Iltimos sho'rni to'ldiring.",
    calculating: 'Hisoblash ...',
    settlementValidation: "Hisob-kitob summasi qolgan miqdordan past yoki teng bo'lishi kerak.",
    additional: "Qo'shimcha",
    addBankInformation: "Bank haqida ma'lumot qo'shing",
    supplierList: "Yetkazib beruvchilar ro'yxati",
    addSupplier: "Yangi yetkazib beruvchini qo'shing",
    supplierEmail: 'Yetkazib beruvchining elektron pochtasi',
    buyerList: "Sotib oluvchilar ro'yxati",
    addBuyer: "Yangi sotib oluvchi qo'shing",
    buyerEmail: 'Sotib oluvchi elektron pochtasi',
    phoneNumber: 'Telefon raqam',
    requiredNote: '* Talab qilinadi',
    createAnother: "Boshqasini qo'shing",
    addParticipantSuccess: "Muvaffaqiyatli qo'shildi.",
    uncdfRegisterText: "Ro'yxatdan o'tish ma'lumotlarini to'ldiring",
    ageRange: 'Yosh darajasi',
    lessThan24: '24 yoshgacha',
    over24: "24 yoki undan ko'p",
    buyerOrSupplier: 'Siz sotib oluvchi yoki yetkazib beruvchi?',
    passwordDidNotMatch: '* Parolni bir-biriga mos kelmasligini tasdiqlang.',
    usernameAlphanumeric: "* Foydalanuvchi ismi maxsus belgilar bo'lolmaydi.",
    usernameMin5: "* Foydalanuvchi nomi kamida 5 ta belgidan iborat bo'lishi kerak.",
    passwordMin: "* Parol kamida 9 ta belgidan iborat bo'lishi kerak.",
    passwordAlphanumeric:
        "* Parolda quyidagilar bo'lishi kerak: raqam, katta harf, maxsus belgilar va kichik harf.",
    userCreated: 'Sizning profilingiz yaratildi.',
    clickHereToLogin: "Kirish sahifasiga o'tish uchun bu yerni bosing.",
    usernameExists: '* Ushbu foydalanuvchi nomi allaqachon olingan.',
    registrationLinkExpired:
        "Ushbu ro'yxatga olish eskirdi, iltimos bizning qo'llab-quvvatlash markazimizga murojaat qiling.",
    male: 'Erkak',
    female: 'Ayol',
    genderNull: 'Aksincha aytmang',
    gender: 'Jins',
    next: 'Keyingi',
    back: 'Orqaga qaytish',
    organizationOrCompany: 'Tashkilot / Kompaniyaning nomi',
    profit: 'Taxminiy foyda',
    npwp: "Soliq to'lovchining identifikatsiya raqami ",
    numberOfEmployees: 'Xodimlar soni',
    community: 'Qayerdansiz?',
    done: 'Bajarildi',
    userProfile: 'Profil',
    businessInformation: "Biznes haqida ma'lumot",
    accountInformation: "Hisob ma'lumotlari",
    finish: 'Tugatmoq',
    tooltipUsername1: 'kamida 5 ta belgi.',
    tooltipPassword1: 'kamida 9 ta belgidan iborat.',
    tooltipPassword2: "katta harf (lar) (A-Z) bo'lishi kerak.",
    tooltipPassword3: "Kichik harflar (lar) (A-Z) bo'lishi kerak.",
    tooltipPassword4: "raqam (lar) (0-9) bo'lishi kerak.",
    tooltipPassword5: " belgilar  bo'lishi kerak (sobiq!, $, # Va boshqalar bo'lishi kerak).",
    organizationNotComplete:
        "Har qanday operatsiyalarni bajarishdan oldin, iltimos,biznes profilingizni to'ldiring",
    alreadyExists: 'allaqachon olingan.',
    billingStatus: 'Hisob-kitob holati',
    actived: 'Faol',
    suspended: "To'xtatib qo'yilgan",
    moneyMovementReport: "Pul harakati to'g'risidagi hisobot",
    trannsactionType: 'Bitim turi',
    activity: 'Faoliyat',
    documents: 'Hujjatlar',
    accountSettings: 'Profil sozlamalari',
    logout: 'Chiqish',
    from: 'Dan',
    to: 'Ga',
    noTaskFound: 'Hech qanday ish topilmadi',
    success: 'Muvaffaqiyat',
    minimumRange: 'Minimal diapazon',
    maximumRange: 'Maksimal diapazon',
    createProduct: 'Mahsulot yarating',
    createInventory: 'Inventarizatsiya yaratish',
    createForm: 'Shaklni yaratish',
    updateForm: 'Formani yangilang',
    form: 'Forma',
    addAnswer: "Javob qo'shing",
    required: 'Talab qilingan',
    formName: 'Forma nomi',
    formDescription: 'Forma tavsifi',
    manageForm: 'Formani boshqarish',
    duplicate: "Nusxa ko'chirmoq",
    fillForm: "Formani to'ldiring",
    editForm: 'Javobni tahrirlash',
    viewForm: "Formani ko'rish",
    answerSubmitted: 'Javob yuborildi.',
    answer: 'Javob',
    dashboard: 'Boshqaruv paneli',
    tasks: 'Vazifalar',
    administration: "Ma'muriyat",
    users: 'Foydalanuvchilar',
    banks: 'Banklar',
    roles: 'Vazifalar',
    programs: 'Dasturlar',
    contracts: 'Shartnomalar',
    jobs: 'Ishlar',
    file: 'Fayl',
    auditTrail: 'Audit tekshiruvlari',
    referenceSourceNav: 'Malumot manbasi',
    reporting: 'Hisobot',
    documentReport: 'Hujjat hisoboti',
    financingReport: 'Moliyaviy hisobot',
    reportEngine: 'Hisobot mexanizmi',
    moneyMovement: 'Pul harakati',
    createDocument: 'Hujjat yaratish',
    quotes: 'Iqtibos',
    invoices: 'Hisob-fakturalar',
    accurate: 'Aniqlik',
    downpayment: "Oldindan to'lov",
    inventory: 'Inventarizatsiya',
    inventoryReport: 'Inventarizatsiya hisoboti',
    invoiceSettlement: 'Hisob-faktura hisob-kitobi',
    products: 'Mahsulotlar',
    contact: 'Aloqa',
    confirmNewPasswordMsg: 'Yangi parolingizni qayta kiriting',
    feeTemplateDetail: "To'lov shablonining tafsilotlari",
    feeName: "to'lov nomi",
    outstanding: 'ajoyib',
    invoicedFee: "faktura qilingan to'lo",
    chargesPlan: "to'lovlar rejasi",
    executionPhase: 'amalga oshirish bosqichi',
    gracePeriod: 'imtiyozli davr',
    oneTime: 'bir marta',
    daily: 'har kuni',
    weekly: 'haftalik',
    monthly: 'oylik',
    preCharges: "oldindan to'lovlar",
    postCharges: "post to'lovlari",
    initiate: 'Boshlash',
    early: 'Erta',
    extension: 'Kengaytma',
    late: 'Kech',
    tierType: 'Darajali turi',
    static: 'Statik',
    dynamic: 'Dinamik',
    formula: 'Formula',
    copy: 'Nusxalash',
    none: 'Yo`q',
    void: 'Bekor',
    postPoned: 'Kechiktirilgan',
    // new translation x4-6459
    signup: 'Ro`yxatdan o`tish',
    userNameMinimalValidation: 'Foydalanuvchi nomi kamida 5 ta belgidan iborat boʻlishi kerak',
    userNameRequiredValidation: 'Foydalanuvchi nomi shart!',
    userNameMatchValidation: 'Foydalanuvchi nomi maxsus belgilarni o`z ichiga olmaydi\n',
    nameMinimalValidation: 'Ism kamida 5 ta belgidan iborat bo`lishi kerak',
    nameRequiredValidation: 'Ism talab qilinadi!',
    mobileNumberMinimalValidation: 'Mobil raqam kamida 10 ta belgidan iborat bo`lishi kerak',
    mobileNumberRequiredValidation: 'Mobil raqam kerak!',
    emailAddressValidation: 'Email manzili noto‘g‘ri',
    emailAddressRequiredValidation: 'Elektron pochta kerak!',
    passwordMinimalValidation: 'Parol kamida 9 ta belgidan iborat bo`lishi kerak!',
    passwordMatchValidation:
        'Parolda quyidagilar bo`lishi kerak: raqamlar, katta harflar, maxsus belgilar va kichik harflar\n',
    passwordRequiredValidation: 'Parol kerak!',
    confirmPassValidation: 'Parol mos kelishi kerak',
    confirmPassRequiredValidation: 'Parolni tasdiqlash talab qilinadi!',
    captchaRequiredValidation: 'Captcha kerak!',
    registerSuccessMessage:
        'Yuborilgandan so`ng foydalanuvchi nomi tekshirilishi mumkin va agar foydalanuvchi nomi allaqachon olingan bo`lsa, captcha yangilanadi',
    createAccountSuccessMessage: 'Hisob yaratish muvaffaqiyati',
    hoverInformation: 'Tugmani yoqib qoʻying ',
    hoverDescription: ' to`liq kasr miqdorini ko`rsatish uchun belgi',
    available: 'Mavjud',
    completed: 'Bajarildi',
    transactionWidget: 'Tranzaksiya',
    overdueTab: 'Muddati o`tgan',
    outstandingTab: 'Ajoyib',
    transactionValue: 'Tranzaksiyaning eng yuqori qiymati',
    viewFullList: 'Toʻliq roʻyxatni koʻrish',
    maximum: 'Maksimal',
    all: 'Hammasi',
    upcomingSettlements: 'Kelgusi hisob-kitoblar',
    participantName: 'Ishtirokchi nomi',
    number: 'Raqam',
    financingOverview: 'Moliyalashtirishga umumiy nuqtai',
    balanceWidget: 'balans hisoboti',
    verifyEmail: 'Elektron pochtani tasdiqlang',
    inventoryList: 'Inventar ro`yxati',
    inventoryDetail: 'Inventarizatsiya tafsilotlari',
    inventoryDetailByDate: 'Sana bo`yicha inventarizatsiya tafsilotlari',
    roleAdd: 'Rol qo`shish',
    roleEdit: 'Rol tahriri',
    createUserProfile: 'Foydalanuvchi profilini yarating',
    editUserProfile: 'Foydalanuvchi profilini tahrirlash',
    editUser: 'Foydalanuvchini tahrirlash',
    createOrganization: 'Tashkilot yaratish',
    editOrganization: 'Tashkilotni tahrirlash',
    createCalendar: 'Kalendar yaratish',
    editCalendar: 'Kalendarni tahrirlash',
    createAuthorization: 'Avtorizatsiya yaratish',
    editAuthorization: 'Avtorizatsiyani tahrirlash',
    organizationAuthDetail: 'Tashkilot avtorizatsiyasi tafsilotlari',
    createSales: 'Savdolarni yaratish',
    editSales: 'Sotishni tahrirlash',
    fileExport: 'Fayl eksporti',
    auditTrailDetail: 'Audit tafsilotlari',
    // new translation x4-6459
    noAttachmentAdded: "Qo'shimcha qo'shilmagan.",
    statusHistory: 'Holat tarixi',
    currentState: 'Hozirgi holat',
    exemption: 'Imtiyoz',
    totalDataSelected: 'Tanlangan jami maʼlumotlar : ',
    creditLimitExpiryDateRemark:
        'Kredit limiti muddati tugagan, iltimos, moliyalashtiruvchi bilan bog‘lanib, uni yangilang.',
    creditLimitModal: 'Ushbu tashkilot uchun kredit muddati tugagan, baribir davom etasizmi ?',
    upfrontBilling: 'Oldindan hisob-kitob',
    bypassFunder: "Fondni chetlab o'tish",
    originAccount: 'Kelib chiqishi Hisob',
    destinationAccount: 'Belgilangan joy Hisob',
    bulkFinancing: 'Katta Moliyalashtirish',
    fundAllocation: "Jamg'arma taqsimlash",
    fundAllocationRateBelow100: "Ratifikani ajratish 100% bo'lishi kerak.",
    fundAllocationRateAbove100: "Ratifikani ajratish 100% bo'lishi kerak.",
    fundAllocationOriginEmpty: 'Iltimos, kelib chiqish hisobini tanlang.',
    fundAllocationDestinationEmpty: 'Iltimos, manzil hisob qaydnomasini tanlang.',
    fundAllocationSubmitted: "Jamg'arma taqsimlanishi.",
    amortizationDate: 'Amortizatsiya sanasi',
    amortizationHistory: 'Amortizatsiya tarixi',
    amortizationAmount: 'Amortizatsiya miqdori',
    addProperty: "Mulk qo'shing",
    valueType: 'Qiymat turi',
    extensionRequest: "Qo'shimcha so'rov",
    extensionTenor: 'Kengaytma tenor',
    activation: 'Faollashtirish',
    feeSettings: 'Haq Sozlash',
    settlementExtension: 'Hal qilish Uzaytirish',
    settlementExtensionSetting: 'Hisoblangan sozlamalar',
    addRabate: "Umumiy daromadni qo'shing",
    rabate: 'Umumiy daromad',
    rabateSetting: 'Umumiy daromad sozlamasi',
    rebateTiering: 'Umumiy daromad sozlamasi',
    vatPercentage: 'QQS ulushi',
    bulkExtension: 'Ommaviy kengaytma',
    bulkExtensionRequestForm: 'Ommaviy kengaytma shakli',
    settlementExtensionRequestForm: "Bo'sh joyni kengaytirish shakli",
    extensionDueDate: 'Uzatilish muddati',
    extensionHistory: 'Kengaytma tarixi',
    extensionFee: 'Kengaytma to`lovi',
    settlementExtensionDueDate: 'Hisob-kitoblarni uzaytirish muddati',
    settlementExtensionHistory: 'Hisob-kitoblarni kengaytirish tarixi',
    settlementExtensionFee: 'Hisob-kitobni uzaytirish to`lovi',
    settlementExtensionTenor: 'Hisobni kengaytirish Tenor',
    selectedDocuments: 'Tanlangan hujjat (lar)',
    pickDate: 'Sanani tanlash uchun bosing...',
    'com.asyx.x4.finprocess.extension.not_found.financing_statement':
        "Moliyalashtirish to'g'risidagi bayonot (lar) topilmadi.",
    'com.asyx.x4.finprocess.extension.invalid_tag':
        "Noto'g'ri holat / teg.Ruxsat berilgan holat / yorliq beriladi / kengaytirilgan.",
    'com.asyx.x4.finprocess.extension.invalid_disbursement': "To'lov topilmadi.",
    'com.asyx.x4.finprocess.extension.multi_payment_date':
        "O'zgarishning ko'p to'lov sanasi bilan hisob-kitoblarni moliyalashtirishni amalga oshirib bo'lmaydi.",
    'com.asyx.x4.finprocess.extension.multi_financing_tenor':
        "O'zgarchilikni moliyalashtirish tipini oluvchi bilan birgalikda moliyalashtirishni amalga oshirib bo'lmaydi.",
    'com.asyx.x4.finprocess.extension.multi_tag':
        "Turli xil maqom bilan hisob-kitoblarni moliyalashtirishni amalga oshirib bo'lmaydi.",
    'com.asyx.x4.finprocess.extension.multi_contract':
        "Turli shartnomalar bilan hisob-kitoblarni moliyalashtirishni amalga oshirib bo'lmaydi.",
    'com.asyx.x4.finprocess.extension.multi_recourse':
        "Turli resurslar bilan hisob-kitoblarni moliyalashtirishni amalga oshirib bo'lmaydi.",
    'com.asyx.x4.finprocess.extension.multi_currency':
        "Turli xil valyutalar bilan hisob-kitoblarni moliyalashtirishni amalga oshirib bo'lmaydi.",
    'com.asyx.x4.finprocess.extension.not_found.contract_participant_stage':
        'Shartnoma ishtirokchisi bosqichi topilmadi.',
    'com.asyx.x4.finprocess.extension.restriction.extension_tenor':
        "Kengaytma tenor kengaytirilgan tenordan ko'proq.",
    'com.asyx.x4.finprocess.extension.waiting_approval.extension':
        'Kengaytmani talab qila olmaydi, chunki hujjat (lar) tasdiqlashni kutmoqda yoki allaqachon uzaytiriladi.',
    extensionRequested: "Qo'shimcha so'rov yuborildi.",
    settlementExtensionRequested: "Hisob-kitobni kengaytirish so'rovi taqdim etildi.",
    'com.asyx.x4.finprocess.extension.restriction.deselect_all':
        "Iltimos, kamida bitta moliyalashtirish to'g'risidagi bayonotni tanlang yoki uning o'rniga vazifani rad eting.",
    'com.asyx.x4.finprocess.extension.restriction.unregistered_financing_statement':
        "Moliyalashtirish bayonnomalari ro'yxatdan o'tmagan.",
    'com.asyx.x4.finprocess.extension.restriction.tenor_exceed': 'Tengor maksimal darajada oshadi',
    'com.asyx.x4.organizationFreeze':
        'Organization is freeze. Please check Credit Limit Expiry Date / Credit Rating / Overdue Transaction. Please contact Bank Administrator.',
    'com.asyx.x4.contractFreeze':
        'Contract is freeze, has occurred overdue amount / overdue days. Please contact Bank administrator.',
    extensionDetail: 'Uzaytirish tafsilotlari',
    settlementExtensionDetail: 'Echimni kengaytirish tafsilotlari',
    extensionID: 'ID kengaytmasi',
    extendedDueDate: 'Kamolotlilik muddati kengayish',
    extensionType: 'Kengaytma turi.',
    transferDetails: 'Tafsilotlarni uzatish',
    retry: 'Takrorlamoq',
    retryBookingOffice: 'Qayta urinish xizmati',
    bookingOfficeExecutionHistory: 'Tarixni tasdiqlash idorasi',
    lastExecutionStartTime: 'Vaqt oxirgi qatlni boshladi',
    lastExecutionEndTime: 'Oxirgi marta ijro etish vaqti',
    duration: 'Davomiylik',
    executions: 'Bajarilish',
    executedBy: 'Bajarilgan',
    beginningStatus: 'Dastlabki holat',
    endStatus: 'Yakuniy holat',
    executionDateTime: 'Bachish sanasi va vaqti',
    deliveryLocation: 'yetkazib berish joyi',
    expetedInvoiceMaturityDate: 'hisob-fakturaning kutilgan muddati',
    descriptionNull: 'Element tavsifi toldirilishi kerak',
    totalAssetPercentage: 'Jami aktiv ulushi',
    transactionInquiry: 'Tranzaksiya so`rovi',
    periodInquiry: 'Davr',
    beginningBalance: 'Boshlang`ich balans',
    totalDebit: 'Jami Debet',
    totalCredit: 'Jami Kredit',
    postDate: 'E`lon qilingan sana',
    journalNo: 'Jurnal Raqami',
    debitOrCredit: 'Debet/Kredit',
    balance: 'Balans',
    configurationTools: 'Konfiguratsiya vositalari',
    participant: 'Ishtirokchi',
    parameterType: 'Parametr turi',
    freezed_account: 'Muzlangan hisob',
    unfreezed_account: 'Infrutize hisobi',
    proposal_after_office_hour: 'Ofis soatidan keyin taklif',
    manual_proposal_creation: "Qo'lda taklifni yaratish",
    without_transfer_approval: 'Transferni tasdiqlashsiz',
    credit_limit_expired_date: 'Kredit limiti muddati tugagan sana',
    vatNull: 'VAT toʼldirilgan yoki tanlangan boʼlishi kerak',
    expectedInvoiceMaturityDate: 'hisob-fakturaning kutilgan muddati',
    pageNumber: 'Sahifa raqami',
    dateFrom: 'Boshlanish sanasi',
    dateTo: 'Tugash sanasi',
    outstandingTransactions: 'Outstanding Transactions',
    fscmOutstanding: 'FSCM Outstanding',
    iconsOutstanding: 'iCons Outstanding',
    financingAfterCutOffTime: 'Vaqtni kesgandan keyin moliyalashtirish',
    rowsPerPage: 'Har bir sahifada qator',
    payFees: "to'lovlarni to'lash",
    cifNumber: 'CIF raqami',
    branchInformation: "Filial haqida ma'lumot",
    yes: 'Dan',
    not: "yo'q",
    ok: 'ok',
    syncOrganizationConfirmationTitle: "Tashkiliy ma'lumotlarni sinxronlashtiring",
    syncOrganizationConfirmationMessage:
        "Siz ushbu tashkilot ma'lumotlarini sinxronlashtirishni xohlaysizmi?",
    synchronizeSuccessMessage: "Ma'lumotlar muvaffaqiyatli sinxronlashtirildi.",
    bulkSyncOrganizationConfirmationMessage:
        "Ushbu tashkilot ma'lumotlarini (lar) sinxronlashtirishni xohlaysizmi?",
    failed: 'Muvaffaqiyatsiz',
    result: 'Natijalar',
    reason: 'Sabab',
    'com.asyx.x4.uoa.synchronize.failed.not_deposit': 'Hisob turi depozit hisobi emas.',
    'com.asyx.x4.uoa.synchronize.failed.not_available': 'Hisob raqami mavjud emas.',
    'com.asyx.x4.uoa.synchronize.failed.no_giro':
        'Ushbu tashkilotda joriy hisob qaydnomasi mavjud emas.',
    syncContractConfirmationTitle: "Shartnoma ma'lumotlarini sinxronlashtirish",
    syncContractConfirmationMessage:
        "Ushbu shartnoma ma'lumotlarini sinxronlashtirishni xohlaysizmi?",
    bulkSyncContractConfirmationMessage:
        "Siz ushbu shartnoma ma'lumotlarini (lar) sinxronlashtirishni xohlaysizmi?",
    'com.asyx.x4.finconfig.synchronize.failed.account_number_not_found':
        "Tashkilot hisob raqami yo'q.",
    'com.asyx.x4.finconfig.synchronize.failed.no_data_from_icons':
        "Piktogrammadan hech qanday javob yo'q, potentsial inflore raqami noto'g'ri.",
    'com.asyx.x4.finconfig.synchronize.failed.contract_participant_not_found':
        'Shartnoma qatnashchilari topilmadi.',
    bulkSettleConfirmation: 'Ommaviy hisob-kitobni tasdiqlash',
    bulkSettleConfirmationMsg: 'Farqi nolga teng emas',
    bulkSettleConfirmationDetail:
        "* Agar siz ushbu jarayonni davom ettirmoqchi bo'lsangiz, iltimos, quyidagi tugmani bosing",
    'login.invalidUsernamePassword': "Sizning ismingiz / parolingiz noto'g'ri.",
    'login.expiredPassword':
        "Sizning parolingiz muddati tugagan, iltimos, ma'murga murojaat qiling.",
    'login.accountLocked': "Sizning hisobingiz qulflangan, iltimos ma'murga murojaat qiling",
    'login.generalFailure': "Serverga ulanib bo'lmadi, iltimos yana urinib ko'ring.",
    welcomeText: 'ASYX X4-ga xush kelibsiz',
    welcome: 'Xush kelibsiz',
    loginToYourAccount: 'hisobingizga kiringт',
    checkMail: 'Elektron pochtangizni tekshiring',
    resetPasswordInstructionMsg:
        "Biz sizning elektron pochtangizga parolni tiklash bo'yicha ko'rsatmani yubordik.",
    'com.asyx.x4.invalid_captcha': "Noto'g'ri CAPTCHA.",
    serverStatus: 'Server holati',
    bniContactUs: "Biz bilan bog'lanish",
    creditDebitNote: 'Kredit/Debet eslatmasi',
    others: 'Boshqa',
    bniRedirectErrorMsg: 'Iltimos, qayta yoʻnaltiring, seans muddati tugadi.',
    bniRedirectManualLogin: "Qo'lda kiring",
    bniRedirectSuccessMsg:
        "Muvaffaqiyatli tizimga kirgan holda, tez orada sizni portalga yo'naltiramiz...",
    bniRedirectSuccessManual: "Agar siz 5 soniyada qayta yo'naltirilmagan bo'lsa, bu erni bosing.",
    bulkSettlement: 'Ommaviy turar joy',
    bulkSettlementConfirmation: 'Ushbu hujjatlar bilan ommaviy turar joyni davom ettiring?',
    bulkSettlementFailed: 'Ommaviy hisob-kitob jarayoni muvaffaqiyatsiz tugadi.',
    'com.asyx.x4.finprocess.settlement.invalid-size':
        "Tanlangan hujjatlar soni kamida 1 yoki undan kam yoki 100 ta hujjatdan iborat bo'lishi kerak.",
    'com.asyx.x4.finprocess.settlement.create.invalid-status':
        "Faqat o'zlashtirilgan, qisman belgilangan, kengaytirilgan yoki kengaytirilgan hisob-kitob holatlari bilan faqat moliyalashtirish..",
    'com.asyx.x4.finprocess.settlement.edit.invalid-status':
        "Tanlangan moliyalashtirish to'g'risidagi hisobotda hisob-kitob holatida bo'lishi kerak.",
    'com.asyx.x4.finprocess.settlement.invalid-currency':
        "Tanlangan moliyalashtirish to'g'risidagi hisobot bir xil valyutaga ega bo'lishi kerak.",
    'com.asyx.x4.finprocess.settlement.invalid-relation':
        "Tanlangan moliyalashtirish to'g'risidagi hisobot bir xil tashkiliy munosabatlarga ega bo'lishi kerak.",
    'com.asyx.x4.finprocess.settlement.invalid-payment-date':
        "Tanlangan hisobni moliyalashtirish to'g'risidagi hisobot bir xil to'lov sanasiga ega bo'lishi kerak.",
    'com.asyx.x4.uoa.organization.failed-delete':
        'Tashkilotni oʻchirib boʻlmadi, tashkilot bilan shartnoma tuzilgan. Iltimos, yana tekshiring.',
    uploadSettlement: 'Hisob-kitobni yuklash',
    FinancingStatementReference: "Moliyaviy hisobot ma'lumotnomasi",
    RepaymentDate: "To'lov sanasi",
    RepaymentAmount: "To'lov summasi",
    ResidualTransferDate: "Qolgan o'tkazish sanasi",
    level: 'Daraja',
    showApprovers: "Tasdiqlovchilarni ko'rish",
    approver: 'Tasdiqlamoq',
    help: 'Yordam bering',
    helpErrorMsg: "Hujjatni yuklab bo'lmadi, yana urinib ko'ring",
    childs: 'Bolalarga',
    limitSettings: 'Cheklovlar',
    followsContractLimit: 'Shartnoma limiti',
    limitAllocation: 'Cheklovni ajratish',
    allocationPercentage: 'Taqsimlash foizi',
    allocationPercentageValidation: 'Umumiy ajratish 100% dan oshmasligi kerak',
    exports: 'Fayl eksporti',
    propertyConfiguration: 'Mulk konfiguratsiyasi',
    penalties: 'Jazo',
    outstandingParameters: 'Taniqli parametrlar',
    disbursementPhases: 'Chet ellashtirish bosqichlari',
    settlementPhases: 'Shoshilinchlik fazalari',
    settlementExtensionPhases: "O'rnatish uchun davom ettirish fazalari",
    accounts: 'Hisoblar',
    generalLedgerSf: 'GL SF sozlamalarini bron qilish',
    generalLedgerDf: 'GL DF sozlamalarini bron qilish',
    generalLedgerSd: 'GL SD sozlamalarini bron qilish',
    data: "Ma'lumotlar",
    message: 'Xabar',
    auditTags: 'Yorliq',
    timestamp: 'Vaqtinchalik',
    process: 'Jarayoni',
    ipAddress: 'IP manzili',
    field: 'Maydon',
    before: 'Oldin',
    after: 'Keyin',
    eventDetail: 'Tadbir tafsilotlari',
    noAdditionalData: "Qo'shimcha ma'lumotlar yo'q",
    holidayList: "Bayramlar ro'yxati",
    holidayFinancingStatement: "Bayramni moliyalashtirish to'g'risidagi bayonot",
    emptyExclusions: '* Iltimos, kamida 1 sanani tanlang',
    downloadTemplate: 'Shablonni yuklab oling',
    uploadOrganizationCalendar: 'Tashkilot taqvimini yuklang',
    fileSelected: 'Tanlangan fayl',
    fileUploaded: 'Faylni muvaffaqiyatli yukladi.',
    autoSettlementDetails: 'Avtomatik hisob-kitob tafsilotlari',
    deleteCalendar: "Taqvimni o'chirish",
    oldData: "Eski ma'lumotlar",
    newData: "Yangi ma'lumotlar",
    cannotDeletePastDate: "O'tgan sana yoki bugun o'chirib bo'lmaydi.",
    invoiceList: "Hisob-fakturalar ro'yxati",
    'com.asyx.x4.document.duplicate_invoice_reference':
        "Hujjatni yangilab bo'lmadi, ma'lumotnoma (lar) mavjud.",
    invoiceApproval: 'Hisob-fakturani tasdiqlash',
    documentInformation: "Hujjat haqida ma'lumot",
    invoiceApprovalEditFirst: 'Avvaliga tahrirlash tugmachasini bosishingiz kerak.',
    referenceAlreadyExist: 'Tizim tizimida qayd etilgan.',
    invalidReference: 'Yaroqsiz mos yozuvlar qiymati.',
    fileTooLarge: 'Maksimal fayl hajmi 50 MB',
    checking: 'Tekshirish...',
    'com.asyx.x4.invoices.exceeds_limit': 'Hisob-faktura miqdori mavjud chegaralardan oshadi',
    passwordUpdated: "Sizning parolingiz muvaffaqiyatli o'zgartirildi.",
    otpSent: 'Otp kodi yuborildi ',
    pleaseVerifyOtpBelow: ', Iltimos, uni quyida tekshiring.',
    didNotReceiveOtp: 'OTP kodini olmadi?',
    resendOtp: 'Qayta tiklash OTP',
    verifyOtp: 'OTP ni tekshiring',
    'com.asyx.x4.incorrect_otp': "Noto'g'ri otp kodi.",
    jobExecutionEnabled: 'Ishni bajarishni faollashtirish',
    addConfiguration: "Konfiguratsiyani qo'shing",
    normalPaymentValue: "Oddiy to'lov qiymati",
    bulkExtensionError:
        "Ushbu bitim uchun ommaviy kengaytma sozlanmagan, iltimos, shartnomaingizni tekshiring yoki ma'mur bilan bog'laning.",
    bulkSettlementExtensionError:
        "Ushbu bitim uchun hisob-kitob uzaytirilmagan, iltimos, shartnomaingizni tekshiring yoki ma'murga murojaat qiling.",
    chooseDate: 'Sanani tanlash uchun bosing ...',
    maxFileSize: 'Faylning maksimal hajmi',
    changeDate: "O'zgartirilgan sana",
    contractNameEmpty: "Yo'qolgan ma'lumot: Shartnoma nomi!",
    currencyContractLimitSettingEmpty:
        'Iltimos, Cheklangan shartnoma sozlamalarida valyutani tanlang!',
    maximumCreditLimitContractEmpty: "Yo'qolgan ma'lumot: Maksimal kredit limiti!",
    overridePercentageContractEmpty: "Ma'lumot etishmayapti: foizni bekor qilish!",
    optionRatesCurrencyEmpty: "Kunlar soni bo'yicha valyutani tanlang!",
    optionRatesDivisorEmpty: "Kunlar soni bo'yicha bo'linuvchini tanlang!",
    proposalRejectionDaysEmpty: "Ma'lumot etishmayapti: Taklifni rad etish kunlari!",
    minimumFinancingTenorEmpty: "Yo'qolgan ma'lumot: Minimal moliyalash Tenor!",
    signatureMessage:
        "Shu bilan biz ro'yxatda keltirilgan Moliyaviy taklif hujjatining tafsilotlarini tasdiqlaymiz.",
    changeAppLogo: "Ilova logotipini o'zgartiring",
    resetAppLogo: 'Qayta tiklash logotipini',
    changeLogo: "Logotipni o'zgartiring",
    overpayment: 'Overpayment',
    underpayment: 'Underpayment',
    pph23: 'PPH23',
    amountDue: 'Amount Due',
    b2bPayment: 'Payment',
    taskDetailEditInformation: "Hujjatni ko'rib chiqing va tafsilotlarni tasdiqlang",
    totalSettlementAmount: 'umumiy hisob-kitob summasi',
    fundAvailable: 'fond mavjud',
    pranota: 'Pra Nota',
    receivedDate: 'Received Date',
    uploadPraNota: 'Upload Pra Nota',
    principal: 'Principal',
    referenceDate: 'Reference Date',
    contractNotFoundBuyer: 'Contract not found for buyer',
    andSupplier: 'and supplier',
    currencyFor: 'Currency for',
    isIrrelevantExistingContract: 'is irrelevant with the existing contract',
    isIrrelevantExistingContractCurrency: 'is irrelevant with the existing contract',
    for: 'for',
    shouldContainValue: 'should contain a value',
    lengthBetween5and50: 'Reference length should be between 5 and 50',
    shouldPositiveAmount: 'should be positive amount',
    isInvalidReference: 'is invalid reference',
    rowCannotEmpty: 'Row data cannot be empty',
    cannotNegativeValue: 'cannot be negative value',
    cannotMoreThan100: 'cannot more than 100',
    cannotFutureDate: 'cannot be a future date',
    cannotLessThan: 'cannot be less than',
    cannotLessThanToday: 'cannot be less than today',
    lengthShouldLessThan255Characters: 'length should be less than 255 characters',
    formatCNDNincorrect:
        'format is incorrect, CN / DN Amount should only numeric, no characters or symbols allowed',
    formatRTRNincorrect:
        'format is incorrect, RTRN Amount should only numeric and always in negative, no characters or symbols allowed except -',
    formatARincorrect:
        'format is incorrect, AR Amount should only numeric and always in positive, no characters or symbols or negative amount allowed',
    formatIncorrect: 'format is incorrect',
    amountShouldNumeric:
        'Amount should only numeric and always in positive, no characters or symbols or negative amount allowed',
    totalAmountMoreThanZero: 'Total amount must more than zero, references',
    withTotalAmount: 'with total amount',
    shouldMore5And365days: 'Payment Term should be more than 0 and less than 365 days',
    activeOrganizationNotRelevant:
        'Active organization is not relevant with the row organization data',
    formatIncorect: 'format incorect',
    formatIsNotCorrect: 'Format is not correct for',
    shouldBeYYYYMMDD: 'It should be YYYYMMDD',
    amountFormatIncorect: 'Format',
    invoiceCode: 'Invoice Reference',
    invoiceamount: 'Invoice Amount',
    numberToDate: 'Payment Term',
    Reference: 'Referensi',
    maximalAmountMsg:
        'The total amount exceeds the system limit. Please revise and ensure it is not more than 15 digits.',
    shortMaximalAmountMsg: 'Total amount cannot more than 15 digits',
    shortMaximalAmountRowMsg: 'Amount cannot more than 15 digits',
    invoicereference: 'Invoice Reference',
    invoicecurrency: 'Invoice Currency',
    invoicedate: 'Invoice Date',
    format: ' ',
    receiveddate: 'Received Date',
    invoicesCannotLessThanToday:
        'Invoices with a date earlier than today cannot be uploaded. Please ensure the invoice date is today or in the future',
};
